export default "__VITE_ASSET__ab572a25__"